import React, { useState, useEffect } from 'react';
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const LockerMenu = (props) => {
    const menuList = [
        {
            title: "Create a store",
            link: "https://app.aicm.store/auth/register?redirect=/create-shop",
            target: "_blank"
        },
        {
            title: "About",
            link: "#About",
        },
        {
            title: "KnowledgeBase",
            link: "#",
            id: "knowledgebase-dropdown",
            customClass: "knowledgebase-dropdown",
        },
        {
            title: "Visit store",
            link: "https://app.aicm.store/",
            customClass: "",
            target: "_blank"
        },
    ];

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            /* Knowledgebase Dropdown */
            .knowledgebase-dropdown {
                position: relative;
                cursor: pointer;
                display: inline-block;
            }

            /* Show the dropdown menu on hover */
            .knowledgebase-dropdown:hover .dropdown-menu,
            .dropdown-menu:hover {
                display: block;
            }

            /* Dropdown menu styling */
          .dropdown-menu {
                display: none;
                position: absolute;
                top: 80%;
                left: 8%;
                min-width: 170px;
                z-index: 1000;
                background: #F4FAFF;
                border-radius: 10px;
                padding: 8px 0;
                border: 3px solid #d5ecff;
                overflow: hidden;
                margin-top: 5px;
            }


            /* Links inside the dropdown */
            .dropdown-menu a {
                display: block;
                padding: 12px 20px;
                text-decoration: none;
                color: #000;
                font-size: 14px;
                transition: background-color 0.3s, color 0.3s;
            }

            /* Hover effect for dropdown links */
            .dropdown-menu a:hover {
                color: #000;
                opacity: 0.9;
            }

            /* Dark theme compatibility */
            [data-theme='dark'] .dropdown-menu a {
                color: #fff;
                background-color: #333;
            }

            /* Icon styling */
            .knowledgebase-dropdown::after {
                content: '\\f107';  /* Font Awesome down arrow */
                font-family: 'Font Awesome 5 Free';
                font-weight: 900;
                font-size: 16px;
                margin-left: 10px;
                transition: transform 0.3s ease, top 0.3s ease;
                position: absolute;
                right: -3%;
                top: 52%;
                transform: translateY(-50%);
            }

            .knowledgebase-dropdown:hover::after {
                transform: translateY(-50%) rotate(180deg); 
            }

            /* Mobile styles */
            .mobile-dropdown {
                display: none;
                padding-left: 15px;
                background-color: rgba(0, 0, 0, 0.05);
                border-radius: 4px;
            }

            .mobile-dropdown.active {
                display: block;
            }

            .mobile-dropdown a {
                padding: 8px 15px;
                display: block;
                text-decoration: none;
                color: #333;
                font-size: 14px;
                transition: background-color 0.3s, color 0.3s;
            }

            /* Mobile dropdown item hover */
            .mobile-dropdown a:hover {
                color: #BF46A2;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        const initDropdown = () => {
            const knowledgeBaseItem = document.querySelector('.knowledgebase-dropdown');

            if (knowledgeBaseItem) {
                // Create dropdown element
                const dropdown = document.createElement('div');
                dropdown.className = 'dropdown-menu';

                // Add dropdown items
                const dropdownItems = [
                    {
                        title: "Create a store",
                        link: "https://aicm-store.gitbook.io/whitepaper/user-guides/service-listing-workflow",
                        target: "_blank"
                    },
                    {
                        title: "Advertise",
                        link: "https://aicm-store.gitbook.io/whitepaper/user-guides/advertising-on-aicm",
                        target: "_blank"
                    },
                    {
                        title: "Affiliate program",
                        link: "https://aicm-store.gitbook.io/whitepaper/user-guides/affiliate-program",
                        target: "_blank"
                    }
                ];

                dropdownItems.forEach(item => {
                    const link = document.createElement('a');
                    link.href = item.link;
                    link.textContent = item.title;
                    if (item.target) {
                        link.target = item.target;
                    }
                    dropdown.appendChild(link);
                });

                knowledgeBaseItem.appendChild(dropdown);
            }

            const mobileKnowledgeBase = document.querySelector('.mobile-menu a[href="#"]');
            if (mobileKnowledgeBase) {
                const mobileDropdown = document.createElement('div');
                mobileDropdown.className = 'mobile-dropdown';

                // Add dropdown items
                const dropdownItems = [
                    {
                        title: "Create a store",
                        link: "https://app.aicm.store/auth/register?redirect=/create-shop",
                        target: "_blank"
                    },
                    {
                        title: "Advertise",
                        link: "https://aicm-store.gitbook.io/whitepaper/user-guides/advertising-on-aicm",
                        target: "_blank"
                    },
                    {
                        title: "Affiliate program",
                        link: "https://aicm-store.gitbook.io/whitepaper/user-guides/affiliate-program",
                        target: "_blank"
                    }
                ];

                dropdownItems.forEach(item => {
                    const link = document.createElement('a');
                    link.href = item.link;
                    link.textContent = item.title;
                    if (item.target) {
                        link.target = item.target;
                    }
                    mobileDropdown.appendChild(link);
                });

                mobileKnowledgeBase.parentNode.insertBefore(mobileDropdown, mobileKnowledgeBase.nextSibling);
                mobileKnowledgeBase.addEventListener('click', function(e) {
                    e.preventDefault();
                    mobileDropdown.classList.toggle('active');
                });
            }
        };

        setTimeout(initDropdown, 500);

        window.addEventListener('load', initDropdown);

        return () => {
            window.removeEventListener('load', initDropdown);
        };
    }, []);

    return (
        <>
            <DesktopMenu menuList={menuList} />
            <MobileMenu menuList={menuList} />
        </>
    );
};

export default LockerMenu;
